import { ConcessaoArquivo } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao-arquivo.entity';

export class ConcessaoArquivoDTO extends ConcessaoArquivo{

    nmArquivo: String;
	nmDocumento: String;
	cdTipoArquivo: number;
    nmTipoArquivo: String;
	dtCriacao: Date;
	blbArquivo: String;

    constructor(
        nmArquivo?: String,
        nmDocumento?: String,
        cdTipoArquivo?: number,
        nmTipoArquivo?: String,
        dtCriacao?: Date,
        blbArquivo?: String
    ){
        super();
        this.nmArquivo = nmArquivo;
        this.nmDocumento = nmDocumento;
        this.cdTipoArquivo = cdTipoArquivo;
        this.nmTipoArquivo = nmTipoArquivo;
        this.dtCriacao = dtCriacao;
        this.blbArquivo = blbArquivo;
    }
}

export class ConcessaoArquivoDTOListDTO {
    items: Array<ConcessaoArquivoDTO>;
    total: number;

    constructor() {}
}